<div class="relative">
  <button
    class="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full dropdown-toggle hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    (click)="toggleDropdown()"
    [attr.aria-label]="'Notificaciones'"
  >
    <!-- Badge: punto animado + contador de no leídas -->
    @if (unreadCount > 0) {
      <span class="absolute -right-0.5 -top-0.5 z-10 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-full bg-orange-400 px-1 text-[10px] font-semibold leading-none text-white">
        <span class="absolute inline-flex w-full h-full bg-orange-400 rounded-full opacity-75 animate-ping"></span>
        <span class="relative">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </span>
    }
    <svg
      class="fill-current"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.75 2.29248C10.75 1.87827 10.4143 1.54248 10 1.54248C9.58583 1.54248 9.25004 1.87827 9.25004 2.29248V2.83613C6.08266 3.20733 3.62504 5.9004 3.62504 9.16748V14.4591H3.33337C2.91916 14.4591 2.58337 14.7949 2.58337 15.2091C2.58337 15.6234 2.91916 15.9591 3.33337 15.9591H4.37504H15.625H16.6667C17.0809 15.9591 17.4167 15.6234 17.4167 15.2091C17.4167 14.7949 17.0809 14.4591 16.6667 14.4591H16.375V9.16748C16.375 5.9004 13.9174 3.20733 10.75 2.83613V2.29248ZM14.875 14.4591V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085C12 17.2943 11.6643 16.9585 11.25 16.9585H8.75004C8.33583 16.9585 8.00004 17.2943 8.00004 17.7085Z"
        fill="currentColor"
      />
    </svg>
  </button>

  <app-dropdown
    [isOpen]="isOpen"
    (close)="closeDropdown()"
    className="absolute -right-[240px] mt-[17px] flex h-[480px] w-[350px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark sm:w-[361px] lg:right-0"
  >
    <!-- Encabezado -->
    <div class="flex items-center justify-between pb-3 mb-3 border-b border-gray-100 dark:border-gray-700">
      <h5 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        Notificaciones
        @if (unreadCount > 0) {
          <span class="ml-1 text-sm font-medium text-orange-500">({{ unreadCount }})</span>
        }
      </h5>
      <div class="flex items-center gap-2">
        @if (unreadCount > 0) {
          <button
            (click)="markAllAsRead()"
            class="text-xs font-medium text-brand-500 transition hover:text-brand-600 dark:text-brand-400"
          >
            Marcar todas
          </button>
        }
        <button
          (click)="closeDropdown()"
          class="text-gray-500 transition dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          aria-label="Cerrar"
        >
          <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Cuerpo -->
    <ul class="flex flex-col flex-1 overflow-y-auto custom-scrollbar">
      @if (loading) {
        <li class="flex items-center justify-center py-10 text-sm text-gray-500 dark:text-gray-400">
          Cargando notificaciones…
        </li>
      } @else if (loadError) {
        <li class="flex items-center justify-center py-10 text-sm text-error-500">
          No se pudieron cargar las notificaciones.
        </li>
      } @else if (notifications.length === 0) {
        <li class="flex flex-col items-center justify-center gap-2 py-12 text-center">
          <span class="flex items-center justify-center w-12 h-12 text-gray-400 bg-gray-100 rounded-full dark:bg-white/5">
            <svg width="24" height="24" viewBox="0 0 20 20" class="fill-current" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085H8.00004Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="text-sm text-gray-500 dark:text-gray-400">No tienes notificaciones</span>
        </li>
      } @else {
        @for (n of notifications; track trackById($index, n)) {
          <li>
            <button
              type="button"
              (click)="onNotificationClick(n)"
              class="flex w-full gap-3 px-2 py-3 text-left transition border-b rounded-lg border-gray-100 hover:bg-gray-100 dark:border-gray-800 dark:hover:bg-white/5"
              [ngClass]="!n.isRead ? 'bg-brand-50 dark:bg-white/[0.03]' : ''"
            >
              <!-- Indicador de no leída -->
              <span class="mt-1.5 flex h-2 w-2 shrink-0 rounded-full"
                    [ngClass]="!n.isRead ? 'bg-brand-500' : 'bg-transparent'"></span>
              <span class="flex flex-col flex-1 min-w-0">
                <span class="text-sm truncate"
                      [ngClass]="!n.isRead ? 'font-semibold text-gray-800 dark:text-white/90' : 'font-medium text-gray-600 dark:text-gray-300'">
                  {{ titulo(n) }}
                </span>
                @if (cuerpo(n); as detalle) {
                  <span class="mt-0.5 line-clamp-2 text-theme-sm text-gray-500 dark:text-gray-400">
                    {{ detalle }}
                  </span>
                }
                <span class="mt-1 text-theme-xs text-gray-400 dark:text-gray-500">
                  {{ formatRelative(n.createdAt) }}
                </span>
              </span>
            </button>
          </li>
        }
      }
    </ul>

    <!-- Pie: ver todas -->
    <a
      routerLink="/notificaciones"
      (click)="closeDropdown()"
      class="block px-4 py-2 mt-3 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
    >
      Ver todas las notificaciones
    </a>
  </app-dropdown>
</div>
